var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"admin-app"}},[_c('pc-singleton-modals',{attrs:{"id":"singleton-admin-modals"}}),_c('pc-singleton-overlay',{attrs:{"id":"singleton-admin-overlay"}}),_c('pc-singleton-snackbar',{attrs:{"id":"singleton-admin-snackbar"}}),(
        _vm.initialAuthenticationRequestComplete &&
        _vm.$store.state.authenticatedUser.isStaffMember()
      )?_c('div',{staticClass:"fill-height"},[_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }